export default "__VITE_ASSET__rEwB6uiE__"